import React from 'react';

import { PrintPaymentSlipLog as PrintPaymentSlipLogInner } from '@components/utilities/PaymentSlip/PrintPaymentSlipLog';

export const PrintPaymentSlipLog = () => {
  return <PrintPaymentSlipLogInner />;
};
